/**
 * Flagship Series Page JavaScript
 * Handles interactive elements and animations for the flagship series page
 */

class FlagshipSeries {
  constructor() {
    // 只在前端环境中初始化
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      this.init();
    }
  }

  init() {
    // 初始化所有组件
    this.initProductCards();
    this.initButtons();
    this.initScrollAnimations();
    this.initSmoothScroll();
    this.initResponsiveLayout();
    this.initLazyLoading();
  }

  // 初始化产品卡片交互
  initProductCards() {
    const productCards = document.querySelectorAll('.flagship-series__product-card');

    productCards.forEach(card => {
      // 增强悬停效果
      card.addEventListener('mouseenter', () => {
        card.style.transform = 'translateY(-8px)';
        card.style.boxShadow = '0 8px 25px rgba(0, 0, 0, 0.15)';
        card.style.transition = 'transform 0.3s ease, box-shadow 0.3s ease';

        // 为图片添加轻微的缩放动画
        const image = card.querySelector('.flagship-series__product-image img');
        if (image) {
          image.style.transform = 'scale(1.1)';
          image.style.transition = 'transform 0.3s ease';
        }
      });

      // 鼠标离开时恢复状态
      card.addEventListener('mouseleave', () => {
        card.style.transform = 'translateY(-5px)';
        card.style.boxShadow = '0 5px 20px rgba(0, 0, 0, 0.1)';

        // 图片恢复原始大小
        const image = card.querySelector('.flagship-series__product-image img');
        if (image) {
          image.style.transform = 'scale(1.05)';
        }
      });

      // 为产品链接添加点击事件（保留在a标签上，不影响链接功能）
      const productLink = card.querySelector('a');
      if (productLink) {
        productLink.addEventListener('click', function () {
          // 记录点击事件但不阻止默认跳转行为
          console.log('Product card clicked, navigating to:', this.getAttribute('href'));
        });
      }

      // 点击卡片其他区域时也触发链接跳转
      card.addEventListener('click', (e) => {
        // 如果点击的是链接或链接内部元素，让浏览器正常处理
        if (e.target.closest('a')) {
          return;
        }

        // 否则查找卡片中的链接并点击
        const link = card.querySelector('a');
        if (link) {
          link.click();
        }
      });
    });
  }

  // 初始化按钮交互
  initButtons() {
    const buttons = document.querySelectorAll('.flagship-series__learn-more-btn');

    buttons.forEach(button => {
      // 按钮悬停效果增强
      button.addEventListener('mouseenter', () => {
        button.style.transform = 'translateY(-2px)';
        button.style.boxShadow = '0 4px 12px rgba(0, 112, 201, 0.3)';
        button.style.transition = 'transform 0.2s ease, box-shadow 0.2s ease';
      });

      button.addEventListener('mouseleave', () => {
        button.style.transform = 'translateY(0)';
        button.style.boxShadow = 'none';
      });

      // 按钮点击效果
      button.addEventListener('mousedown', () => {
        button.style.transform = 'translateY(0)';
      });

      button.addEventListener('mouseup', () => {
        button.style.transform = 'translateY(-2px)';
      });
    });
  }

  // 初始化滚动动画
  initScrollAnimations() {
    const animateOnScroll = () => {
      // 产品卡片动画
      const productCards = document.querySelectorAll('.flagship-series__product-card');
      productCards.forEach(card => {
        const cardPosition = card.getBoundingClientRect().top;
        const screenPosition = window.innerHeight / 1.3;

        if (cardPosition < screenPosition && !card.classList.contains('animated')) {
          card.style.opacity = 1;
          card.style.transform = 'translateY(0)';
          card.classList.add('animated');
        }
      });

      // 区域标题动画
      const sectionTitles = document.querySelectorAll('.flagship-series__section-title');
      sectionTitles.forEach(title => {
        const titlePosition = title.getBoundingClientRect().top;
        const screenPosition = window.innerHeight / 1.2;

        if (titlePosition < screenPosition && !title.classList.contains('animated')) {
          title.style.opacity = 1;
          title.style.transform = 'translateY(0)';
          title.classList.add('animated');
        }
      });
    };

    // 设置初始样式
    const productCards = document.querySelectorAll('.flagship-series__product-card');
    productCards.forEach(card => {
      card.style.opacity = 0;
      card.style.transform = 'translateY(30px)';
      card.style.transition = 'opacity 0.7s ease, transform 0.7s ease';
    });

    // 区域标题初始样式
    const sectionTitles = document.querySelectorAll('.flagship-series__section-title');
    sectionTitles.forEach(title => {
      title.style.opacity = 0;
      title.style.transform = 'translateY(20px)';
      title.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
    });

    // 添加滚动事件监听器
    window.addEventListener('scroll', animateOnScroll);

    // 初始化时触发一次
    animateOnScroll();
  }

  // 初始化平滑滚动
  initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();

        const targetId = this.getAttribute('href');
        const targetElement = document.querySelector(targetId);

        if (targetElement) {
          window.scrollTo({
            top: targetElement.offsetTop - 100, // 减去顶部导航高度的偏移量
            behavior: 'smooth'
          });
        }
      });
    });
  }

  // 初始化响应式布局调整
  initResponsiveLayout() {
    const handleResize = () => {
      const viewportWidth = window.innerWidth;
      const productCards = document.querySelectorAll('.flagship-series__product-card');

      // 在移动设备上调整产品卡片的样式
      if (viewportWidth < 768) {
        productCards.forEach(card => {
          card.style.width = '100%';
          card.style.minWidth = 'auto';
        });
      } else {
        // 平板设备上
        if (viewportWidth < 1024) {
          productCards.forEach(card => {
            card.style.width = 'calc(50% - 15px)';
            card.style.minWidth = '250px';
          });
        } else {
          // 桌面设备上
          productCards.forEach(card => {
            card.style.width = 'calc(25% - 22.5px)';
            card.style.minWidth = '250px';
          });
        }
      }

      // 切换响应式背景图片
      this.handleBackgroundImageSwitch(viewportWidth);
    };

    // 初始执行一次
    handleResize();

    // 监听窗口大小变化
    window.addEventListener('resize', handleResize);
  }

  // 处理背景图片响应式切换
  handleBackgroundImageSwitch(viewportWidth) {
    console.log('Background image switch triggered, viewport width:', viewportWidth);

    // 检查图片URL是否是默认的"无图片"占位符
    const isDefaultImage = (url) => {
      return url && (url.includes('no-image') || url.includes('placeholder'));
    };

    // 存储解决方案banner
    const storageBanner = document.querySelector('.flagship-series__storage-banner');
    if (storageBanner) {
      const desktopBg = storageBanner.getAttribute('data-desktop-bg');
      const mobileBg = storageBanner.getAttribute('data-mobile-bg');

      console.log('Storage Banner - Desktop BG:', desktopBg);
      console.log('Storage Banner - Mobile BG:', mobileBg);

      console.log('Storage Banner - mobileBg:', mobileBg);
      if (viewportWidth < 768 && mobileBg && !isDefaultImage(mobileBg)) {
        console.log('Switching Storage Banner to mobile image:', mobileBg);
        storageBanner.style.backgroundImage = `url(${mobileBg})`;
      } else if (desktopBg) {
        console.log('Switching Storage Banner to desktop image:', desktopBg);
        storageBanner.style.backgroundImage = `url(${desktopBg})`;
      }
    } else {
      console.log('Storage Banner not found');
    }

    // 扩展坞解决方案banner
    const dockingBanner = document.querySelector('.flagship-series__docking-banner');
    if (dockingBanner) {
      const desktopBg = dockingBanner.getAttribute('data-desktop-bg');
      const mobileBg = dockingBanner.getAttribute('data-mobile-bg');

      console.log('Docking Banner - Desktop BG:', desktopBg);
      console.log('Docking Banner - Mobile BG:', mobileBg);

      if (viewportWidth < 768 && mobileBg && !isDefaultImage(mobileBg)) {
        console.log('Switching Docking Banner to mobile image:', mobileBg);
        dockingBanner.style.backgroundImage = `url(${mobileBg})`;
      } else if (desktopBg) {
        console.log('Switching Docking Banner to desktop image:', desktopBg);
        dockingBanner.style.backgroundImage = `url(${desktopBg})`;
      }
    } else {
      console.log('Docking Banner not found');
    }
  }

  // 初始化图片懒加载
  initLazyLoading() {
    if ('IntersectionObserver' in window) {
      const imgObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target;
            const src = img.getAttribute('data-src');

            if (src) {
              img.setAttribute('src', src);
              img.removeAttribute('data-src');

              // 添加淡入效果
              img.style.opacity = '0';
              img.style.transition = 'opacity 0.5s ease';

              // 触发回流并设置最终不透明度
              setTimeout(() => {
                img.style.opacity = '1';
              }, 10);
            }

            observer.unobserve(img);
          }
        });
      });

      document.querySelectorAll('img[data-src]').forEach(img => {
        imgObserver.observe(img);
      });
    }
  }
}

// 初始化旗舰系列页面
document.addEventListener('DOMContentLoaded', () => {
  // 只在旗舰系列页面初始化
  if (typeof document !== 'undefined' && document.querySelector('.flagship-series')) {
    new FlagshipSeries();
  }
});

// 确保Shopify主题能够正确加载此脚本
if (typeof window !== 'undefined') {
  window.FlagshipSeries = FlagshipSeries;
}